<template>
	<div class="page">
		<NavBar title="绑定手机号" />
		<Form @submit="onSubmit">
		  <Field
			  v-model="phone"
			  name="手机号"
			  label="手机号"
			  placeholder="请输入手机号"
		  />
			<Field
				v-model="sms"
				center
				clearable
				label="短信验证码"
				placeholder="请输入短信验证码"
			>
			  <template #button>
			    <span v-if="!sendFlag" size="small" type="primary" @click="onSmsClick">发送验证码</span>
			    <span v-if="sendFlag" size="small" type="primary">{{ time }}s 后重新发送</span>
			  </template>
			</Field>
		  <div style="margin: 60px 30px;">
		    <Button round block type="danger" native-type="submit" :loading="loading">
		      提交
		    </Button>
		  </div>
		</Form>
	</div>
</template>

<script>
	import { NavBar, Form, Field, Button } from 'vant';
	import request from '../request.js'
  let inter
	export default {
	  components: {NavBar, Form, Field, Button},
		data() {
	    return {
        phone: '',
        sms: '',
        time: 30,
        smsId: 0,
        sendFlag: false,
        relashFlag: false,
        loading: false
	    }
		},
    destroyed() {
	    clearInterval(inter)
    },
    methods: {
      onSmsClick() {
        this.time = 30
        this.sendFlag = true
        this.relashFlag = true
        this.$axiox.post('/sms/send', {
          phone: this.phone
        }).then(p => {
          this.smsId = p.data.id
          inter = setInterval(p => {
            this.time --
            if (this.time === 0) {
              this.sendFlag = false
              clearInterval(inter)
            }
          }, 1000)
        })
      },
      onSubmit() {
        this.$axiox.post('/sms/checkCode', {
          code: this.sms,
          id: this.smsId,
          phone: this.phone
        }).then(p => {
          if (p.data.result === '验证成功') {
            this.loading = true;
            const newOpenId = localStorage.getItem('huozhewang_openId') || '';
            const userInfo = JSON.parse(localStorage.getItem('huozhewang_userInfo') || '{"openid": "", "nickname": "匿名", "headimgurl": ""}');
            // alert(JSON.stringify(userInfo))
            const { openid, nickname, headimgurl } = userInfo;
            request.post('/account/reg', {
              openId: openid || newOpenId,
              userName: nickname,
              headImg: headimgurl,
              phone: this.phone,
              channel:1
            })
                .then((register) => {
                  return request.get(`/account/login?openId=${ openid }`)
                      .then(async (data) => {
                        this.$store.commit('setUserFromJava', data);
                        this.$store.commit('setToken', data.token);
                        this.loading = false
                        await this.$store.dispatch('fetchBanners');
                        await this.$store.dispatch('fetchGoods', {});
                        await this.$store.dispatch('fetchHeadingNews');
                        await this.$store.dispatch('fetchMarket', {});
                        this.$router.push('/tabs/home')
                      })
                      .catch(err => {
                        this.$commonJs.showTips(err)
                        this.loading = false
                      })
                })
                .catch(err => {
                  this.$commonJs.showTips(err)
                  this.loading = false
                })
          } else {
            this.$commonJs.showTips('验证码不正确')
          }
        })
      }
		}
	}
</script>
